//ANCHOR PAGEVIEW (INIT GA4)
window.GTM_PUSH({ event: 'page_viewed' }).then(() => {
  //ANCHOR VIEW_ITEM
  if (THEME_INFO.pageType == 'product') {
    GtmDataExtractor.sendViewEvent('gtm-view-item', {
      event: 'view_item',
      method: 'load',
    })
    setTimeout(() => {
      const el = document.getElementById('relatedColorSizes')
      if (el) {
        el.addEventListener('onSelectVariant', (event) => {
          window.eventFetch(
            window.THEME_INFO.productId,
            event.detail.variant.variantId,
            {
              event: 'selected_variant',
              method: 'selected',
            }
          )
        })
      }
    }, 2000)
  }
  //ANCHOR VIEW_Item_list
  if (THEME_INFO.pageType == 'collection') {
    GtmDataExtractor.sendViewEvent('gtm-collections', {
      event: 'view_item_list',
      method: 'load',
    })
    document.addEventListener('collection:reloaded', function () {
      GtmDataExtractor.sendViewEvent('gtm-collections', {
        event: 'view_item_list',
        method: 'refresh',
      })
    })
  }
  //ANCHOR CART_EVENTs
  document.addEventListener('cart:updated', function (evt) {
    let cart = evt.detail.cart
    let method = THEME_INFO.pageType == 'cart' ? 'cart_page' : 'sidebar'
    let event =
      cart.items_removed.length > 0 ? 'remove_from_cart' : 'add_to_cart'
    let productCart =
      cart.items_removed.length > 0
        ? cart.items_removed[0]
        : cart.items_added[0]
    window.eventFetch(productCart.product_id, productCart.variant_id, {
      event: event,
      method: method,
    })
  })
  document.addEventListener('ajaxProduct:added', function (evt) {
    let productCart = evt.detail.product
    window.eventFetch(productCart.product_id, productCart.variant_id, {
      event: 'add_to_cart',
      method: 'pdp',
    })
  })
  if (THEME_INFO.pageType == 'search') {
    GtmDataExtractor.sendViewEvent('grid--uniform', {
      event: 'search',
      method: 'load',
    })
  }
})
